export const isTripV2Enabled = (): boolean => process.env.NEXT_PUBLIC_FF_ENABLE_TRIP_V2 === 'true';
